// Styles for LoyaltyTier go here.
import styled from 'styled-components';

export const StyledLoyaltyTier = styled.div``;
